import {
  AfterContentInit,
  OnDestroy,
  Component,
  ViewChild,
  HostListener,
  Input,
  ElementRef,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { MainNavComponent } from '@app/core/header/components/main-nav/main-nav.component';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
import { IAppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import * as fromUser from '@app/core/user/store/reducers';
import { PlatformService } from '../../shared/services/platform/platform.service';
import { Subject } from 'rxjs';
import * as UserActions from '@app/core/user/store/actions/user.actions';
import * as HeaderActions from '@app/core/header/store/actions/header.action';
import * as headerReducers from '@app/core/header/store/reducers';
import { takeUntil } from 'rxjs/operators';
import { getDirectShippingEligibility } from '@app/core/i18n/store/reducers';
import { HeaderBadgeDetail, UsersService } from '@vestiaire/api-sdk-angular';
import { PreventScrollService } from '@app/shared/services/prevent-scroll/prevent-scroll.service';

@Component({
  selector: 'vc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements AfterContentInit, OnDestroy, OnChanges {
  message: any;
  isLogged: any;
  userInfo$: any;
  isMainNavOpenedOnMobile = false;
  isCartPreviewOpened = false;
  stickyDisabled = false;
  directShippingEligible = false;
  needGetPaidAction = false;

  // Control flow for scrolling
  scrollY = 0;
  private ngUnsubscribe = new Subject<void>();

  @Input() hasBanner: boolean;
  public previewBox__cart_right_pos = 0;
  public headerBadgeDetail: HeaderBadgeDetail;

  constructor(
    private platformService: PlatformService,
    private helpers: HelpersService,
    private store: Store<IAppState>,
    private element: ElementRef,
    private usersService: UsersService,
    private preventScrollService: PreventScrollService
  ) {
    this.store
      .select(getDirectShippingEligibility)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: res => {
          this.directShippingEligible = res;
        }
      });

    this.store
      .select(headerReducers.getMeBadge)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: res => (this.needGetPaidAction = res)
      });
  }

  @ViewChild('nav', { static: false })
  private nav: MainNavComponent;
  public isMdUp;
  public isSearchActive = false;
  public userWallet = new Subject();

  ngAfterContentInit() {
    if (this.platformService.isBrowser) {
      this.store.select('device').subscribe(
        device => {
          if (device) {
            this.isMdUp = device.isMdUp;
          }
        },
        () => {
          /* Silently catch exception */
        }
      );
      this.store.pipe(select(fromUser.isAuthenticated)).subscribe(
        res => {
          this.isLogged = res;
          if (res) {
            this.setCounterBadgeOnStore();
            this.store.pipe(select(fromUser.getUser)).subscribe(
              user => {
                this.userInfo$ = user;
              },
              () => {
                /* Silently catch exception */
              }
            );
          }
          this.store.pipe(select(fromUser.getWallet)).subscribe(
            wallet => {
              this.userWallet.next(wallet);
            },
            () => {
              /* Silently catch exception */
            }
          );
        },
        () => {
          /* Silently catch exception */
        }
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isLogged && changes.isLogged.currentValue && !changes.isLogged.previousValue) {
      this.setCounterBadgeOnStore();
    } else {
      this.store.pipe(select(headerReducers.getCounters)).subscribe(
        res => {
          this.headerBadgeDetail = res;
        },
        () => {
          /* Silently catch exception */
        }
      );
    }
  }

  ngOnDestroy() {
    this.preventScrollService.allowScrollOnBody();
  }

  setCounterBadgeOnStore(): void {
    this.usersService.getCounters().subscribe(
      res => {
        if (res.data.notificationCount) {
          // Notification count is now handled by notification web component
          delete res.data['notificationCount'];
        }
        this.headerBadgeDetail = res.data;
        this.store.dispatch({
          type: HeaderActions.SET_COUNTERS_NUMBERS,
          payload: res.data
        });
      },
      error => {
        console.log(error);
      }
    );
  }

  setItemToStore(products) {
    this.store.dispatch({
      type: UserActions.SET_USER_LIKED_ITEMS,
      payload: products
    });
  }

  bindMenuForMobile() {
    this.isMainNavOpenedOnMobile = true;
    this.preventScrollService.preventScrollOnBody();
  }

  closeMobileMainMenu() {
    this.isMainNavOpenedOnMobile = false;
    this.preventScrollService.allowScrollOnBody();
  }

  closeMenuLevel3_onDesktop() {
    if (this.helpers.device.isMdUp() && this.nav.mainNav) {
      this.nav.resetMenuStateFromLevel(this.nav.mainNav);
    }
  }

  activeSearchClass(e) {
    this.isSearchActive = e;
  }

  @HostListener('document:click', ['$event'])
  handleClick(event: Event) {
    const cart = this.element.nativeElement.querySelector('.accessCart');
    if (!cart.contains(event.target)) {
      this.isCartPreviewOpened = false;
    }
  }

  cartAction() {
    this.isCartPreviewOpened = !this.isCartPreviewOpened;
    this.setPreviewBoxPosition('cart');
  }

  setPreviewBoxPosition(type) {
    const iconElem = this.element.nativeElement.getElementsByClassName('accessItem__' + type);
    const iconPos = iconElem[0] ? iconElem[0].getBoundingClientRect() : {};
    const accessElem = this.element.nativeElement.getElementsByClassName('mainLine__innerWrapper');
    const accessItemPos = accessElem[0] ? accessElem[0].getBoundingClientRect() : {};

    const deltaAlignment = 21.5 - iconPos.width / 2; // to align middle of the arrow with middle of icon

    const rightPos = (accessItemPos.right - iconPos.right || 0) - deltaAlignment;
    this['previewBox__' + type + '_right_pos'] = rightPos + 'px';
  }

  closeBoxes(eventValue) {
    if (eventValue) {
      this.closePreviewBox();
    }
  }

  closePreviewBox() {
    this.isCartPreviewOpened = false;
  }
}
